import type { GCLDimension } from '@/types/dojo';

/**
 * The five HOW dimensions in canonical order, with their colours taken from the
 * Ethos design tokens (`how-dimension.*` in lightning-design-system/projects/ethos).
 * Every surface that colours a dimension (the Your HOW ring, practice activity
 * markers, the animated wordmark) reads from here so a palette change in the
 * design system re-skins all of them at once.
 */
export const HOW_DIMENSIONS: readonly GCLDimension[] = ['KNOW', 'BEHAVE', 'RELATE', 'RECOGNIZE', 'PURSUE'];

export const HOW_DIMENSION_COLOR: Record<GCLDimension, string> = {
  KNOW: 'var(--color-how-dimension-know)',
  BEHAVE: 'var(--color-how-dimension-behave)',
  RELATE: 'var(--color-how-dimension-relate)',
  RECOGNIZE: 'var(--color-how-dimension-recognize)',
  PURSUE: 'var(--color-how-dimension-pursue)',
};

export const HOW_DIMENSION_TITLE: Record<GCLDimension, string> = {
  KNOW: 'How you know',
  BEHAVE: 'How you behave',
  RELATE: 'How you relate',
  RECOGNIZE: 'How you recognize',
  PURSUE: 'How you pursue',
};

/** Five equal wedges, one per dimension, starting at twelve o'clock. */
export const HOW_DIMENSION_RING = `conic-gradient(from -90deg, ${HOW_DIMENSIONS.map((dimension, index) => {
  const wedge = 360 / HOW_DIMENSIONS.length;
  return `${HOW_DIMENSION_COLOR[dimension]} ${index * wedge}deg ${(index + 1) * wedge}deg`;
}).join(', ')})`;
